import {FaAward} from 'react-icons/fa'
import { FaUniversity } from "react-icons/fa"
import {TbBooks} from 'react-icons/tb'
import { FaLaptopCode } from "react-icons/fa"


const data = [
    {id: 1, icon: <FaAward/>, title: 'Working Experience', desc: '3+ Years'},
    {id: 2, icon: < FaUniversity/>, title: 'NTUA - MEng Mechanical Engineering', desc: '2015 - 2022'},
    // {id: 3, icon: <TbBooks/>, title: 'Projects', desc: '5+ Completed'},
    // {id: 4, icon: <FaLaptopCode/>, title: 'Software/Web Development', desc: '1+ Years'}
    ]



    export default data;